import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as DetailsIcon } from "assets/svgs/Details.svg";
import { ReactComponent as MinusIcon } from "assets/svgs/Minus.svg";

import { LandmarkTypesNames } from "lib/consts/navigation/map";

const LandmarkRow = ({
    name = "",
    isSelected = false,
    onSelectLandmark = () => {},
    onDelete = () => {},
}) => {
    return (
        <div className="flex w-full  space-x-2">
            <FunctionalButton
                className={`h-6 w-6 cursor-pointer rounded-r5 ${isSelected && "bg-primary2"}`}
                icon={<DetailsIcon />}
                onClick={onSelectLandmark}
            />
            <p className="text-h5 flex-grow rounded-r3 bg-black70 p-1 text-black40">{name}</p>
            <FunctionalButton
                className="h-6 w-6 rounded-full bg-warning p-1"
                icon={<MinusIcon />}
                onClick={onDelete}
            />
        </div>
    );
};

const EditLandmarksSection = ({
    landmarkType = "",
    landmarkInfos = {},
    selectedLandmark,
    onSelectLandmark = () => {},
}) => {
    return (
        <div className="flex h-fit w-full flex-col items-start justify-start space-y-1">
            <p className="text-h5 font-light">{LandmarkTypesNames[landmarkType]}</p>
            <div className="w-full space-y-2">
                {landmarkInfos.map((info, id) => {
                    let _info = { id: `${landmarkType}-${info.name}`, ...info, type: landmarkType };
                    return (
                        <LandmarkRow
                            key={id}
                            {...info}
                            isSelected={selectedLandmark?.id === _info.id}
                            onSelectLandmark={() =>
                                selectedLandmark && selectedLandmark?.id === _info.id
                                    ? onSelectLandmark(null)
                                    : onSelectLandmark(_info)
                            }
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default EditLandmarksSection;
